import React from "react";


const TagsInput = props => {
	const [tags, setTags] = React.useState(props.tags);
	const removeTags = indexToRemove => {
		setTags([...tags.filter((_, index) => index !== indexToRemove)]);
	};
	const addTags = event => {
		if (event.target.value !== "") {
			setTags([...tags, event.target.value]);
			props.selectedTags([...tags, event.target.value]);
			event.target.value = "";
		}
	};
	return (
		<div className="tags-input" >
			<ul id="tags">
				{tags.map((tag, index) => (
					<li key={index} className="tag">
						<span className='tag-title'>{tag}</span>
						<span className='tag-close-icon'
							onClick={() => removeTags(index)}
						>
							
						</span>
					</li>
				))}
			</ul>
			<input
				type="text"
				required={tags && tags.length > 0 ? false: true}
				onKeyUp={event => event.key === " " ? addTags(event) : null}
				onKeyPress={event=>{
					if (!/^[a-zA-Z]/.test(event.key) ) { 
						event.preventDefault();
					}
				}}
				placeholder="Press space to add tags"
				class="tagsStyle" 
			/>
		</div>
	);
};

export default TagsInput;



